import { Injectable } from "@angular/core";
import { ChallengeSubscription, ContentSubscription } from "@edp-models/challenge.model";
import { ApiService } from "@edp-services/api.service";

@Injectable({
    providedIn: "root",
})
export class ChallengesService {
    constructor(private apiService: ApiService) {}

    public getChallengesLevels() {
        return this.apiService.callServicePostToCollection(`individualChallenge.getChallenges`, {});
    }

    public getEvent(eventType?: string, challengeId?: string, eventCode?: string) {
        return this.apiService.callServicePostToCollection(`collectiveChallenge.getEvent`, { eventType, challengeId, eventCode });
    }

    public getEventsList(eventCode?: string, eventType?: string, limit?: number, state?: string) {
        return this.apiService.callServicePostToCollection(`collectiveChallenge.getEventsList`, { eventCode, eventType, limit, state });
    }

    public individualChallengeSubscription(args: ChallengeSubscription) {
        return this.apiService.callServicePost(`individualChallenge.subscribe`, args);
    }

    public collectiveChallengeSubscription(args: ChallengeSubscription) {
        return this.apiService.callServicePost(`collectiveChallenge.subscribe`, args);
    }

    public collectiveChallengeUnSubscription(args: ChallengeSubscription) {
        return this.apiService.callServicePost(`collectiveChallenge.unSubscribe`, args);
    }

    public contentChallengeSubscription(args: ContentSubscription) {
        return this.apiService.callServicePost("content.subscribe", args);
    }
}
